import CitySEOHead from "@/components/feature/CitySEOHead";
import EsteroHeroSection from "./components/HeroSection";
import EsteroStickyNav from "./components/StickyNav";
import EsteroProcessingTimeSection from "./components/ProcessingTimeSection";
import EsteroServicesSection from "./components/ServicesSection";
import EsteroLocalAreaSection from "./components/LocalAreaSection";
import EsteroTravelTimingSection from "./components/TravelTimingSection";
import EsteroDestinationsSection from "./components/DestinationsSection";
import EsteroTestimonialsSection from "./components/TestimonialsSection";
import EsteroAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import EsteroComparisonSection from "./components/ComparisonSection";
import EsteroMistakesSection from "./components/MistakesSection";
import EsteroHowItWorksSection from "./components/HowItWorksSection";
import EsteroFAQSection, { faqs } from "./components/FAQSection";
import EsteroHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import EsteroFinalCTA from "./components/FinalCTA";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function EsteroPage() {
  return (
    <>
      <CitySEOHead
        city="Estero"
        state="Florida"
        stateAbbr="FL"
        route="/cities/estero"
        title="Emergency Passport Estero, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Estero, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Southwest Florida and Lee County travelers."
        geoPlacename="Estero, Florida"
        geoPosition="26.4381;-81.8068"
        faqs={faqs}
        servicesSchema={servicesSchema}
      />
      <div className="font-sans">
        <EsteroHeroSection />
        <EsteroStickyNav />
        <EsteroProcessingTimeSection />
        <EsteroServicesSection />
        <EsteroLocalAreaSection />
        <EsteroTravelTimingSection />
        <EsteroDestinationsSection />
        <EsteroTestimonialsSection />
        <EsteroAcceptanceFacilitiesSection />
        <EsteroComparisonSection />
        <EsteroMistakesSection />
        <EsteroHowItWorksSection />
        <EsteroFAQSection />
        <EsteroHelpfulResourcesSection />
        <EsteroFinalCTA />
      </div>
    </>
  );
}